// eslint-disable-next-line import/no-extraneous-dependencies
import { ExpandableBottomCard, TextLink, Button } from 'baby-design'
import { useWindowSize } from 'usehooks-ts'
import { BREAKPOINT_MOBILE } from 'src/constants'
import FadeOut from '../../../../../../components/transitions/FadeOut'
import { SignUpBannerTreatmentProps } from './types'
import css from './SignUpCard.styles.scss'

const SignUpBannerT2 = ({
  scrolled,
  previouslyDismissed,
  onDismissal,
  onClick,
  onDisplay,
  ctaPath,
}: SignUpBannerTreatmentProps) => {
  const isMobile = useWindowSize().width < BREAKPOINT_MOBILE
  return (
    <FadeOut animateOnEnter show={scrolled}>
      <ExpandableBottomCard
        openOnLoad={!previouslyDismissed}
        summaryContent={
          <span className={css.summaryContent}>
            Ready to create your registry?{' '}
            <TextLink
              underline
              href={`${ctaPath}?loc=Banner+Collapsed+Link`}
              variant="eggplant"
              onClick={() => onClick('Sign up')}
            >
              Sign&nbsp;up
            </TextLink>
          </span>
        }
        onClose={onDismissal}
        onOpen={onDisplay}
      >
        <p className={css.expandedContent}>
          <strong>Start building your baby registry</strong>
          <ul>
            <li>
              Add anything from any store
              {!isMobile && ', including Target, Amazon, and more!'}
            </li>
            <li>Guides & advice to help you find what you&nbsp;need</li>
            <li>Track your pregnancy and get weekly&nbsp;updates</li>
          </ul>
        </p>

        <Button
          href={`${ctaPath}?loc=Banner+Button+T2`}
          size={isMobile ? 'sm' : 'md'}
          variant="primary"
          onClick={() => onClick('Sign up today')}
        >
          Sign&nbsp;up&nbsp;today
        </Button>
      </ExpandableBottomCard>
    </FadeOut>
  )
}

export default SignUpBannerT2
